import { matchPath, NavLink, useLocation } from 'react-router'
import classNames from 'classnames'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { MENU_ITEM_COUNTER_MAX_VALUE } from '../../../constants/menu'
import { useContentOverflow } from '../../../hooks'
import { preventDefault } from '../../../utils/events'
import { getWebappLinkPrefix } from '../../../utils/route'
import { Counter } from '../../Counter'
import { FloatingTooltip } from '../../Floating'
import { IconNG } from '../../Icon'

import * as styles from './MenuItem.module.css'

function MenuItem({
  Icon,
  activeClassName = styles.active,
  blocked,
  className = styles.MenuItem,
  collapsed,
  counter,
  counterClassName = styles.counter,
  isAvailable,
  text,
  to,
  webappTo,
}) {
  const { pathname } = useLocation()

  const link = isAvailable ? to : getWebappLinkPrefix(webappTo ?? to)

  const { overflow, setContentOverflowRef } = useContentOverflow({
    dep: [text, collapsed],
  })

  function getClassName({ isActive }) {
    return classNames(className, {
      [activeClassName]: isActive,
      [styles.blocked]: blocked,
    })
  }

  function handleClick(event) {
    if (blocked || matchPath({ end: true, path: to }, pathname)) {
      preventDefault(event)
    }
  }

  return (
    <FloatingTooltip
      content={text}
      disabled={collapsed ? false : !overflow}
      placement={FLOATING_ELEMENT_PLACEMENT.right}
    >
      <NavLink
        aria-disabled={blocked || undefined}
        className={getClassName}
        end={to === '/'}
        reloadDocument={!isAvailable}
        tabIndex={blocked ? -1 : undefined}
        to={link}
        onAuxClick={handleClick}
        onClick={handleClick}
      >
        <IconNG Icon={Icon} className={styles.icon} />

        {collapsed ? null : (
          <span className={styles.text} ref={setContentOverflowRef}>
            {text}
          </span>
        )}

        {counter > 0 ? (
          <Counter
            className={counterClassName}
            count={counter}
            maxCount={MENU_ITEM_COUNTER_MAX_VALUE}
          />
        ) : null}
      </NavLink>
    </FloatingTooltip>
  )
}

export default MenuItem
